import AdminViewQuilty from "../views/admin/AdminViewQuilty.vue";
import { UserRole } from "@gsx/common";
import { Container } from "inversify";

import ReportsListView from "../views/admin/reports/ReportsListView.vue";
import ReportsCreateView from "../views/admin/reports/ReportsCreateView.vue";
import ReportsEditView from "../views/admin/reports/ReportsEditView.vue";
import ReportGeneralView from "../views/admin/reports/ReportGeneralView.vue";

import { AuthGate } from "../../../common/src/AuthGate";
import { RouteConfig } from "vue-router";

export const createThirdPartyAdminRoutes = (container: Container): RouteConfig[] => {
    const authGate: AuthGate = container.get(AuthGate);

    return [
        {
            path: "/quiltyAdmin",
            redirect: "/quiltyAdmin/reports",
            component: AdminViewQuilty,
            beforeEnter: authGate.requireAuthorizedGuard([UserRole.ThirdpartyAdmin]),
            meta: {
                breadcrumbs: [
                    {
                        name: "Home",
                        to: "/",
                    },
                    {
                        name: "Admin",
                        to: "/quiltyAdmin",
                    },
                ],
            },
            children: [
                {
                    path: "reports",
                    component: ReportsListView,
                    meta: {
                        title: "Reports",
                    },
                },
                {
                    path: "reports/create",
                    component: ReportsCreateView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Reports",
                                to: "/quiltyAdmin/reports",
                            },
                        ],
                        title: "Create",
                    },
                },
                {
                    path: "reports/:reportId",
                    component: ReportsEditView,
                    redirect: "reports/:reportId/general",
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Reports",
                                to: "/quiltyAdmin/reports",
                            },
                        ],
                        title: "Edit",
                    },
                    children: [
                        {
                            path: "general",
                            component: ReportGeneralView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Report",
                                        to: "/quiltyAdmin/general/:reportId",
                                    },
                                ],
                                title: "General",
                            },
                        },
                    ],
                },
            ],
        },
    ];
};
